<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center cursor-pointer
        xl:max-w-30rem lg:max-w-30rem md:max-w-30rem"
        @click="popup_show()">
        <div class="w-full flex flex-row border-round-2xl surface-300 py-5 px-3">
            <span class="flex flex-1 text-700 font-medium xl:text-xl">
                {{ header[lang_] }}
            </span>
            <i class="pi pi-window-maximize text-700" style="font-size: 1rem"></i>
        </div>
    </div> 
    <Dialog v-model:visible="popup" modal :header="header[lang_]" 
        class="w-full ml-4 mr-4 border-round-xl" style="max-width: 560px;">
        <div class="w-full">
            <p>
                {{ content[lang_].step1 }}
            </p>
            <p>
                {{ content[lang_].step2 }}
            </p>
            <p>
                {{ content[lang_].step3 }}
            </p>
            <img src="/images/info/instructions/permata_cash/permata_cash1.jpg" class="w-full">
            <p>
                {{ content[lang_].step4 }}
            </p>
            <img src="/images/info/instructions/permata_cash/permata_cash2.jpg" class="w-full">
            <p>
                {{ content[lang_].step5 }}
            </p>
            <img src="/images/info/instructions/permata_cash/permata_cash3.jpg" class="w-full">
            <p>
                {{ content[lang_].step6 }}
            </p>
        </div>
    </Dialog>
</template>


<script>
import { ref } from "vue";
import Helper from '@/assets/js/Helper'
export default {
    props: [],
	data(){
		return{
            popup: false,
            header: {
                ru: "Как снять наличные в АТМ Permata",
                en: "How to withdraw cash from Permata ATM",
            },
			content: {
                ru: {
					step1: "1. Найдите зеленый банкомат Permata Me в вашем городе.",
                    step2: "2. Как только окажетесь у банкомата - напишите заранее оператору и оставайтесь на связи.",
                    step3: "3. Нажмите кнопку Mobile Cash на главном экране банкомата Permata.",
                    step4: "4. Введите номер телефона указанный в переводе (начиная с 0) и нажмите кнопку Correct.",
                    step5: "5. Запросите код подтверждения у оператора, введите его в банкомат и нажмите кнопку Correct.",
                    step6: "6. Банкомат выдаст вам наличные. Готово.",
				},
				en: {
					step1: "1. Find a green Permata Me ATM in your city.",
                    step2: "2. Once you are at the ATM - write to the operator in advance and stay in touch.",
                    step3: "3. Press the Mobile Cash button on the main screen of the Permata ATM.",
                    step4: "4. Enter the phone number specified in the transfer (starting with 0) and press the Correct button.",
                    step5: "5. Request a confirmation code from the operator, enter it into the ATM and press the Correct button.",
                    step6: "6. The ATM will dispense cash to you. Done.",
                },
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
	methods: {
        popup_show(){
            this.popup = true
        },
	},
	async beforeCreate() {
        this.helper = new Helper()
	}
}
</script>